import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Input, Label, Row, Col } from "reactstrap";
import {
  getMemberBenefitsv2,
  updateMasterMemberBenefitsv2,
} from "../../../store/slices/memberBenefitsSlice";
import { H5 } from "../../../AbstractElements";
import CreatetableSelect from "react-select/creatable";

const MemberBenefitsCopy = ({ program,reload }) => {
  const dispatch = useDispatch();
  const [mbCards, setMbCards] = useState([]);
  console.log(mbCards,"MB CARDS");
  
  const [render, setRender] = useState(false);

  const [benefitMode] = useState([
    { value: "complementary", label: "Complementary" },
    { value: "value", label: "Value" },
  ]);
  const [typeOfBenefit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);
  const [valueBenefitType] = useState([
    { value: "percentage", label: "Percentage" },
    { value: "flat", label: "Flat" },
  ]);
  const rollbackTypeOptions = [
    { value: "registration", label: "Registration" },
    { value: "login_time", label: "Login Time" },
    { value: "financial_year", label: "Financial Year" },
  ];
  const rollbackTimeOptions = [
    { value: "days_30", label: "1 Month" },
    { value: "days_60", label: "2 Months" },
    { value: "days_90", label: "3 Months" },
    { value: "days_365", label: "12 Months" },
  ];

  useEffect(() => {
    console.log(reload,"RELOADDDD ");
    
    getMBofProgram();
  }, [program,reload]);

  const getMBofProgram = async () => {
    let MBDATA = await dispatch(getMemberBenefitsv2(program.ID));
    if (MBDATA?.payload?.services?.length > 0) {
      setMbCards(MBDATA?.payload?.services);
    }
  };

  const handleInputService = (event, index, field) => {
    let cards = [...mbCards];
    const val = event?.target ? event.target.value : event?.value;
    
    cards[index] = { ...cards[index], [field]: val, isEdit: true };
    if (field === "mbValue" || field === "total_quantity" || field === "total_percentage") {
      cards[index][field] = parseInt(val) || 0;
    }
    setMbCards(cards);
    setRender(!render);
  };

  const handleInputSubService = (event, mainindex, subServiceIndex, field) => {
    let cards = [...mbCards];
    const val = event?.target ? event.target.value : event?.value;

    cards[mainindex].sub_services[subServiceIndex] = {
      ...cards[mainindex].sub_services[subServiceIndex],
      [field]: val,
      isEdit: true,
    };
    if (field === "mbValue" || field === "total_quantity" || field === "total_percentage") {
       cards[mainindex].sub_services[subServiceIndex][field] = parseInt(val) || 0;
    }
    setMbCards(cards);
    setRender(!render);
  };

  const handleInputCategory = (event, mainindex, subServiceIndex, catIndex, field) => {
    let cards = [...mbCards];
    const val = event?.target ? event.target.value : event?.value;

    cards[mainindex].sub_services[subServiceIndex].categories[catIndex] = {
      ...cards[mainindex].sub_services[subServiceIndex].categories[catIndex],
      [field]: val,
      isEdit: true,
    };
    if (field === "mbValue" || field === "total_quantity" || field === "total_percentage") {
        cards[mainindex].sub_services[subServiceIndex].categories[catIndex][field] = parseInt(val) || 0;
     }
    setMbCards(cards);
    setRender(!render);
  };

  const handleInputSubCategory = (event, mainindex, subServiceIndex, catIndex, subCatIndex, field) => {
    let cards = [...mbCards];
    const val = event?.target ? event.target.value : event?.value;

    cards[mainindex].sub_services[subServiceIndex].categories[catIndex].sub_categories[subCatIndex] = {
      ...cards[mainindex].sub_services[subServiceIndex].categories[catIndex].sub_categories[subCatIndex],
      [field]: val,
      isEdit: true,
    };
    if (field === "mbValue" || field === "total_quantity" || field === "total_percentage") {
        cards[mainindex].sub_services[subServiceIndex].categories[catIndex].sub_categories[subCatIndex][field] = parseInt(val) || 0;
     }
    setMbCards(cards);
    setRender(!render);
  };

 const executeUpdate = async (currentCard, successCallback) => {
    console.log(currentCard, "currentCard");
    
    let updatePayload = {
      ID: currentCard.ID , 
      mbValue: currentCard.mbValue,
      total_quantity: currentCard.total_quantity,     
      total_percentage: currentCard.total_percentage, 
      rollbackType: currentCard.rollbackType,         
      rollbackTime: currentCard.rollbackTime,
      benefittype: currentCard.benefittype,
      benefitMode: currentCard.benefitMode,
      valueBenefitType: currentCard.valueBenefitType,
      max_amount: currentCard.max_amount,
      amount_to_pay: currentCard.amount_to_pay,
    };

    Object.keys(updatePayload).forEach(key => {
      if (updatePayload[key] === undefined) {
        delete updatePayload[key];
      }
    });

    try {
      let result = await dispatch(updateMasterMemberBenefitsv2(updatePayload));
      if (result?.payload) {
        successCallback();
      } else {
        console.error("Update failed: No payload returned from API.");
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const updateParentMB = (card, index) => {
    executeUpdate(card, () => {
      let cards = [...mbCards];
      delete cards[index].isEdit;
      setMbCards(cards);
      setRender(!render);
    });
  };

  const updateSubServiceMB = (imb, mainindex, subServiceIndex) => {
    console.log(imb,"IMBBB");
    
    executeUpdate(imb, () => {
      let cards = [...mbCards];
      delete cards[mainindex].sub_services[subServiceIndex].isEdit;
      setMbCards(cards);
      setRender(!render);
    });
  };

  const updateCategoryMB = (cat, mainindex, subServiceIndex, catIndex) => {
    console.log(cat, mainindex, subServiceIndex, catIndex,"CATEGORY INDEX");
    
    executeUpdate(cat, () => {
      let cards = [...mbCards];
      
      delete cards[mainindex].sub_services[subServiceIndex].categories[catIndex].isEdit;
      setMbCards(cards);
      setRender(!render);
    });
  };

  const updateSubCategoryMB = (subCat, mainindex, subServiceIndex, catIndex, subCatIndex) => {
    console.log(subCat, mainindex, subServiceIndex, catIndex,subCatIndex,"SUB CATEGORY INDEX");

    executeUpdate(subCat, () => {
      let cards = [...mbCards];
      delete cards[mainindex].sub_services[subServiceIndex].categories[catIndex].sub_categories[subCatIndex].isEdit;
      setMbCards(cards);
      setRender(!render);
    });
  };

  return (
    <div className="mb-container">
      {mbCards?.map((card, index) => (
        <Card className="p-4 mb-4 bg-white rounded shadow-sm border-0 border-start border-4 border-primary" key={`mbCard-${index}`}>
          
          {/* ----- LEVEL 1: MAIN SERVICE (PRIMARY / BLUE) ----- */}
          <H5 className="text-primary fw-bold mb-3 border-bottom pb-2">{card?.service_name}</H5>
          
          <Row className="mb-3">
            <Col md="6">
              <Label>Type of Benefit</Label>
              <CreatetableSelect
                options={typeOfBenefit}
                onChange={(e) => handleInputService(e, index, "benefittype")}
                value={typeOfBenefit.find((x) => x.value === card.benefittype)}
              />
            </Col>
            {card.benefittype === "grouped" && (
              <Col md="6">
                <Label>Select mode</Label>
                <CreatetableSelect
                  options={benefitMode}
                  onChange={(e) => handleInputService(e, index, "benefitMode")}
                  value={benefitMode.find((x) => x.value === card.benefitMode)}
                  isClearable
                />
              </Col>
            )}
          </Row>

          {card.benefitMode === "value" && card.benefittype === "grouped" && (
            <Row className="mb-3">
              <Col md="6">
                <Label>Select mode</Label>
                <CreatetableSelect
                  options={valueBenefitType}
                  onChange={(e) => handleInputService(e, index, "valueBenefitType")}
                  value={valueBenefitType.find((x) => x.value === card.valueBenefitType)}
                  isClearable
                />
              </Col>
              <Col md="6">
                <Label>Amount/Percentage</Label>
                <Input
                  type="number"
                  placeholder="Enter amount/percentage"
                  value={card.total_percentage || ""}
                  max={card.valueBenefitType === "percentage" ? 100 : null}
                  onChange={(e) => handleInputService(e, index, "total_percentage")}
                />
              </Col>
            </Row>
          )}

          {card?.benefittype === "grouped" && (
            <Row className="mb-3">
              <Col md="6">
                <Label>MB count for grouped</Label>
                <Input
                  type="number"
                  placeholder="Enter count"
                  value={card.mbValue || ""}
                  onChange={(e) => handleInputService(e, index, "mbValue")}
                />
              </Col>
              <Col md="6">
                <Label>Max amount</Label>
                <Input
                  type="text"
                  placeholder="Enter max amount"
                  value={card.max_amount || ""}
                  onChange={(e) => handleInputService(e, index, "max_amount")}
                />
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col md="6">
              <Label>Roleback Type</Label>
              <CreatetableSelect
                options={rollbackTypeOptions}
                onChange={(e) => handleInputService(e, index, "rollbackType")}
                value={rollbackTypeOptions.find((x) => x.value === card.rollbackType)}
              />
            </Col>
            <Col md="6">
              <Label>Rollback Time</Label>
              <CreatetableSelect
                options={rollbackTimeOptions}
                onChange={(e) => handleInputService(e, index, "rollbackTime")}
                value={rollbackTimeOptions.find((x) => x.value === card.rollbackTime)}
                isClearable
              />
            </Col>
          </Row>

          {card?.isEdit && (
            <div className="d-flex justify-content-end mb-3">
              <Button color="primary" onClick={() => updateParentMB(card, index)}>
                Save Service
              </Button>
            </div>
          )}

          {/* ----- SCROLL CONTAINER FOR NESTED ITEMS ----- */}
          {card.benefittype === "individual" && (
            <div className="bg-light p-3 rounded border individual-benefits-scroll-container" style={{ maxHeight: "600px", overflowY: "auto" }}>
              {card?.sub_services?.map((imb, imbIndex) => (
                
                /* ----- LEVEL 2: SUB SERVICES (DANGER / RED) ----- */
                <Card className="p-4 mb-4 bg-white rounded shadow-sm border-0 border-start border-4 border-danger" key={`SubService-${imbIndex}`}>
                  <H5 className="text-danger fw-bold mb-3 border-bottom pb-2">{imb?.sub_service_name}</H5>
                  <Row className="mb-3">
                    <Col md="6">
                      <Label>Type of Benefit</Label>
                      <CreatetableSelect
                        options={typeOfBenefit}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "benefittype")}
                        value={typeOfBenefit.find((x) => x.value === imb.benefittype)}
                        isClearable
                      />
                    </Col>
                    <Col md="6">
                      <Label>Select mode</Label>
                      <CreatetableSelect
                        options={benefitMode}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "benefitMode")}
                        value={benefitMode.find((x) => x.value === imb.benefitMode)}
                        isClearable
                      />
                    </Col>
                  </Row>

                  {imb.benefitMode === "value" && imb.benefittype === "grouped" &&(
                    <Row className="mb-3">
                      <Col md="6">
                        <Label>Select mode</Label>
                        <CreatetableSelect
                          options={valueBenefitType}
                          onChange={(e) => handleInputSubService(e, index, imbIndex, "valueBenefitType")}
                          value={valueBenefitType.find((x) => x.value === imb.valueBenefitType)}
                          isClearable
                        />
                      </Col>
                      <Col md="6">
                        <Label>Amount/Percentage</Label>
                        <Input
                          type="number"
                          placeholder="Enter amount/percentage"
                          value={imb.total_percentage || ""}
                          onChange={(e) => handleInputSubService(e, index, imbIndex, "total_percentage")}
                        />
                      </Col>
                    </Row>
                  )}

                 {imb.benefittype === "grouped" && ( <Row className="mb-3">
                    <Col md="6">
                      <Label>MB count</Label>
                      <Input
                        type="number"
                        placeholder="Enter count"
                        value={imb.mbValue || ""}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "mbValue")}
                      />
                    </Col>
                    <Col md="6">
                      <Label>Max amount</Label>
                      <Input
                        type="text"
                        placeholder="Enter max amount"
                        value={imb.max_amount || ""}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "max_amount")}
                      />
                    </Col>
                  </Row>)}

                  <Row className="mb-3">
                    <Col md="6">
                      <Label>Roleback Type</Label>
                      <CreatetableSelect
                        options={rollbackTypeOptions}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "rollbackType")}
                        value={rollbackTypeOptions.find((x) => x.value === imb.rollbackType)}
                      />
                    </Col>
                    <Col md="6">
                      <Label>Rollback Time</Label>
                      <CreatetableSelect
                        options={rollbackTimeOptions}
                        onChange={(e) => handleInputSubService(e, index, imbIndex, "rollbackTime")}
                        value={rollbackTimeOptions.find((x) => x.value === imb.rollbackTime)}
                        isClearable
                      />
                    </Col>
                  </Row>

                  {imb?.isEdit && (
                    <div className="d-flex justify-content-end mb-3">
                      <Button color="danger" className="text-white" onClick={() => updateSubServiceMB(imb, index, imbIndex)}>
                        Save Sub Service
                      </Button>
                    </div>
                  )}

                  {/* ----- LEVEL 3: CATEGORIES (WARNING / YELLOW-ORANGE) ----- */}
                  {imb.benefittype === "individual" && imb?.categories?.map((cat, catIndex) => (
                    <div className="ms-4 mt-4 p-3 bg-white rounded shadow-sm border-0 border-start border-4 border-warning" key={`Category-${catIndex}`}>
                      <h6 className="fw-bold text-warning mb-3 border-bottom pb-2">{cat?.category_name}</h6>
                      
                      <Row className="mb-3">
                        <Col md="6">
                          <Label>Type of Benefit</Label>
                          <CreatetableSelect
                            options={typeOfBenefit}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "benefittype")}
                            value={typeOfBenefit.find((x) => x.value === cat.benefittype)}
                            isClearable
                          />
                        </Col>
                        <Col md="6">
                          <Label>Select mode</Label>
                          <CreatetableSelect
                            options={benefitMode}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "benefitMode")}
                            value={benefitMode.find((x) => x.value === cat.benefitMode)}
                            isClearable
                          />
                        </Col>
                      </Row>

                      {cat.benefitMode === "value" &&  cat.benefittype==="grouped" &&(
                        <Row className="mb-3">
                          <Col md="6">
                            <Label>Select mode</Label>
                            <CreatetableSelect
                              options={valueBenefitType}
                              onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "valueBenefitType")}
                              value={valueBenefitType.find((x) => x.value === cat.valueBenefitType)}
                              isClearable
                            />
                          </Col>
                          <Col md="6">
                            <Label>Amount/Percentage</Label>
                            <Input
                              type="number"
                              placeholder="Enter amount/percentage"
                              value={cat.total_percentage || ""}
                              onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "total_percentage")}
                            />
                          </Col>
                        </Row>
                      )}

                     {cat?.benefittype === "grouped" && (
                      <Row className="mb-3">
                        <Col md="6">
                          <Label>MB count</Label>
                          <Input
                            type="number"
                            placeholder="Enter count"
                            value={cat.mbValue || ""}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "mbValue")}
                          />
                        </Col>
                        <Col md="6">
                          <Label>Max amount</Label>
                          <Input
                            type="text"
                            placeholder="Enter max amount"
                            value={cat.max_amount || ""}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "max_amount")}
                          />
                        </Col>
                      </Row>
                       )}

                      <Row className="mb-3">
                        <Col md="6">
                          <Label>Roleback Type</Label>
                          <CreatetableSelect
                            options={rollbackTypeOptions}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "rollbackType")}
                            value={rollbackTypeOptions.find((x) => x.value === cat.rollbackType)}
                          />
                        </Col>
                        <Col md="6">
                          <Label>Rollback Time</Label>
                          <CreatetableSelect
                            options={rollbackTimeOptions}
                            onChange={(e) => handleInputCategory(e, index, imbIndex, catIndex, "rollbackTime")}
                            value={rollbackTimeOptions.find((x) => x.value === cat.rollbackTime)}
                            isClearable
                          />
                        </Col>
                      </Row>

                      {cat?.isEdit && (
                        <div className="d-flex justify-content-end mb-3">
                          <Button color="warning" className="text-dark" onClick={() => updateCategoryMB(cat, index, imbIndex, catIndex)}>
                            Save Category
                          </Button>
                        </div>
                      )}

                      {/* ----- LEVEL 4: SUB CATEGORIES (SECONDARY / GRAY) ----- */}
                      {cat.benefittype === "individual" && cat?.sub_categories?.map((subCat, subCatIndex) => (
                        <div className="ms-4 mt-3 p-3 bg-white rounded shadow-sm border-0 border-start border-4 border-secondary" key={`SubCategory-${subCatIndex}`}>
                          <h6 className="fw-bold text-secondary mb-3 border-bottom pb-2">{subCat?.sub_category_name}</h6>
                          
                          <Row className="mb-3">
                            <Col md="6">
                              <Label>Type of Benefit</Label>
                              <CreatetableSelect
                                options={typeOfBenefit}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "benefittype")}
                                value={typeOfBenefit.find((x) => x.value === subCat.benefittype)}
                                isClearable
                              />
                            </Col>
                            <Col md="6">
                              <Label>Select mode</Label>
                              <CreatetableSelect
                                options={benefitMode}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "benefitMode")}
                                value={benefitMode.find((x) => x.value === subCat.benefitMode)}
                                isClearable
                              />
                            </Col>
                          </Row>

                          {subCat.benefitMode === "value" && subCat.benefittype === "grouped" && (
                            <Row className="mb-3">
                              <Col md="6">
                                <Label>Select mode</Label>
                                <CreatetableSelect
                                  options={valueBenefitType}
                                  onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "valueBenefitType")}
                                  value={valueBenefitType.find((x) => x.value === subCat.valueBenefitType)}
                                  isClearable
                                />
                              </Col>
                              <Col md="6">
                                <Label>Amount/Percentage</Label>
                                <Input
                                  type="number"
                                  placeholder="Enter amount/percentage"
                                  value={subCat.total_percentage || ""}
                                  onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "total_percentage")}
                                />
                              </Col>
                            </Row>
                          )}

                         {subCat?.benefittype === "grouped" && (
                          <Row className="mb-3">
                            <Col md="6">
                              <Label>MB count</Label>
                              <Input
                                type="number"
                                placeholder="Enter count"
                                value={subCat.total_quantity || ""}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "total_quantity")}
                              />
                            </Col>
                            <Col md="6">
                              <Label>Max amount</Label>
                              <Input
                                type="text"
                                placeholder="Enter max amount"
                                value={subCat.max_amount || ""}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "max_amount")}
                              />
                            </Col>
                          </Row>
                           )}

                          <Row className="mb-3">
                            <Col md="6">
                              <Label>Roleback Type</Label>
                              <CreatetableSelect
                                options={rollbackTypeOptions}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "rollbackType")}
                                value={rollbackTypeOptions.find((x) => x.value === subCat.rollbackType)}
                              />
                            </Col>
                            <Col md="6">
                              <Label>Rollback Time</Label>
                              <CreatetableSelect
                                options={rollbackTimeOptions}
                                onChange={(e) => handleInputSubCategory(e, index, imbIndex, catIndex, subCatIndex, "rollbackTime")}
                                value={rollbackTimeOptions.find((x) => x.value === subCat.rollbackTime)}
                                isClearable
                              />
                            </Col>
                          </Row>

                          {subCat?.isEdit && (
                            <div className="d-flex justify-content-end">
                              <Button color="secondary" onClick={() => updateSubCategoryMB(subCat, index, imbIndex, catIndex, subCatIndex)}>
                                Save Sub Category
                              </Button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </Card>
              ))}
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};

export default MemberBenefitsCopy;